import script from "./ProjectsEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectsEffect.vue?vue&type=script&setup=true&lang=js"

import "./ProjectsEffect.vue?vue&type=style&index=0&id=2b2112ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2112ac"]])

export default __exports__